import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/ui';

// Nine features, all of them things the app actually does today — drawn from the
// release notes in busLineApp/assets/changelog.json rather than from a wishlist.
// If one of these is ever removed from the app, it has to be removed here too.
const FEATURES = [
    { id: 'record', icon: '⏺' },
    { id: 'paths', icon: '🛣' },
    { id: 'infoIcons', icon: '⚠️' },
    { id: 'markers', icon: '📍' },
    { id: 'schedules', icon: '🗓' },
    { id: 'drives', icon: '🚌' },
    { id: 'company', icon: '👥' },
    { id: 'offline', icon: '📶' },
    { id: 'languages', icon: '🌍' },
] as const;

export const Features: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Section
            id="features"
            eyebrow={t('web.features.eyebrow')}
            title={t('web.features.title')}
            sub={t('web.features.sub')}
        >
            <div className="grid grid--3">
                {FEATURES.map((feature) => (
                    <article className="tile" key={feature.id}>
                        <div className="tile__icon" aria-hidden="true">{feature.icon}</div>
                        <h3 className="tile__title">{t(`web.features.${feature.id}.name`)}</h3>
                        <p className="tile__body">{t(`web.features.${feature.id}.body`)}</p>
                    </article>
                ))}
            </div>
        </Section>
    );
};
